import {message, Skeleton, Space} from "antd";
import {useFormContext} from "react-hook-form";
import {EditLiveEventBasicFormStepFormValues} from "../schema-validation";
import {FormFieldError} from "../../../../design-system/form-field";
import {useGetLiveEventContext} from "../context/get-live-event";
import {LiveEventCoverImagesFormFields} from "../../../../components/offering-form/live-events/cover-images";
import {
  useLiveEventCoverImagesDelete,
  useLiveEventUploadCoverImages,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../features/media";

export function EditLiveEventCoverImagesUpload() {
  const {
    state: {liveEventData},
  } = useGetLiveEventContext();
  const {setValue, watch, formState} =
    useFormContext<EditLiveEventBasicFormStepFormValues>();
  const liveEventUploadCoverImagesMutation = useLiveEventUploadCoverImages();
  const liveEventCoverImagesDeleteMutation = useLiveEventCoverImagesDelete();

  // Fetch cover images via v2 with fallback to embedded data
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "live-class",
    offeringId: liveEventData.id,
    embedded: liveEventData.cover_images,
  });

  // Convert domain format back to API format for existing component
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    liveEventCoverImagesDeleteMutation.mutate(
      {mediaId, offeringId},
      {
        onSuccess: () => {
          const currentCoverImages = watch("cover_images");

          const newValues = currentCoverImages.filter((x) => x.id !== mediaId);
          setValue("cover_images", newValues);
          message.success("Deleted successfully");
        },
      }
    );
  }

  // Show loading skeleton while fetching cover images
  if (isCoverImagesLoading) {
    return (
      <div>
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <Skeleton.Image active style={{width: 200, height: 120}} />
        </Space>
      </div>
    );
  }

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <LiveEventCoverImagesFormFields
          accordionIndex={0}
          liveEventData={{
            id: liveEventData.id,
          }}
          defaultCoverImages={coverImagesForDisplay}
          deleteCoverImage={handleCoverImagesItemDelete}
          isDeleteLoading={liveEventCoverImagesDeleteMutation.isLoading}
          isUploadLoading={liveEventUploadCoverImagesMutation.isLoading}
          offeringId={liveEventData.id}
          uploadCoverImages={liveEventUploadCoverImagesMutation}
        />
        <FormFieldError errorMessage={formState.errors.cover_images?.message} />
      </Space>
    </div>
  );
}
